import instance from "@/utils/require.js"

// 标签模版--分页查询
export function apiLabelTemplateSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/label_template/search",
		method: "post",
		data
	})
}

// 标签模版--新建模板
export function apiLabelTemplateAdd(data = {}) {
	return instance({
		url: "/aim/api/v3/label_template/add",
		method: "post",
		data
	})
}
export function apiLabelTemplateDelete(data = {}) {
	return instance({
		url: "/aim/api/v3/label_template/delete",
		method: "post",
		data
	})
}

// 标签模版--产品类别下拉
export function apiProductTypeList(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/product_type",
		method: "post",
		data
	})
}

// 标签模版--产品型号下拉
export function apiProductList(data = {}) {
	return instance({
		url: "/aim/api/v3/product/list",
		method: "post",
		data
	})
}

// 标签模版--客户下拉
export function apiCustomerList(data = {}) {
	return instance({
		url: "/aim/api/v3/customer/list",
		method: "post",
		data
	})
}

// 标签模版--标签类型下拉
export function apiLabelTypeList(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/label_type",
		method: "post",
		data
	})
}

// 标签模版--打印机类型下拉
export function apiPrinterTypeList(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/printer_type",
		method: "post",
		data
	})
}

// 标签模版--模板详情
export function apiLabelTemplateDetail(data = {}) {
	return instance({
		url: "/aim/api/v3/label_template/detail",
		method: "post",
		data
	})
}

// 标签模版--修改模板
export function apiLabelTemplateUpdate(data = {}) {
	return instance({
		url: "/aim/api/v3/label_template/update",
		method: "post",
		data
	})
}

// 标签模版--还原打印机指令
export function apiLabelTemplateRollback(data = {}) {
	return instance({
		url: "/aim/api/v3/label_template/commands/rollback",
		method: "post",
		data
	})
}

// 字体管理--字体查询
export function apiFontSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/label_template/font/search",
		method: "post",
		data
	})
}

// 字体管理--添加字体
export function apiFontAdd(data = {}) {
	return instance({
		url: "/aim/api/v3/label_template/font/add",
		method: "post",
		data
	})
}

// 字体管理--编辑字体
export function apiFontUpdate(data = {}) {
	return instance({
		url: "/aim/api/v3/label_template/font/update",
		method: "post",
		data
	})
}

// 字体管理--启用字体
export function apiFontEnable(data = {}) {
	return instance({
		url: "/aim/api/v3/label_template/font/enable",
		method: "post",
		data
	})
}

// 字体管理--禁用字体
export function apiFontDisable(data = {}) {
	return instance({
		url: "/aim/api/v3/label_template/font/disable",
		method: "post",
		data
	})
}

// 字体管理--上移字体
export function apiFontMoveUp(data = {}) {
	return instance({
		url: "/aim/api/v3/label_template/font/move_up",
		method: "post",
		data
	})
}

// 字体管理--下移字体
export function apiFontMoveDowm(data = {}) {
	return instance({
		url: "/aim/api/v3/label_template/font/move_down",
		method: "post",
		data
	})
}
